import { render, staticRenderFns } from "./OrderFacets.vue?vue&type=template&id=3e7457e3&"
import script from "./OrderFacets.vue?vue&type=script&lang=ts&"
export * from "./OrderFacets.vue?vue&type=script&lang=ts&"
import style0 from "./OrderFacets.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports